import {
	connect
} from 'react-redux'
import GearSpecEditComponent from '../components/GearSpecEditComponent.jsx';
import {
	changeGearSpecValue,
	addGearSpec,
	editGearSpec,
	findAllGears,
	findAllModelNos
} from '../actions';

const mapStateToProps = (state) => ({
	gearSpec: state.getIn(['gearSpecReducer', 'gearSpec']),
	gearSpecValidation: state.getIn(['gearSpecReducer', 'gearSpecValidation']),
	alertStyle: state.getIn(['gearSpecReducer', 'alertStyle']),
	alertMessage: state.getIn(['gearSpecReducer', 'alertMessage']),
	forInsert: state.getIn(['gearSpecReducer', 'forInsert']),
	allGears: state.getIn(['commonReducer', 'allGears']),
	allModelNos: state.getIn(['gearSpecReducer', 'allModelNos']),

	activePage: state.getIn(['gearSpecListReducer', 'activePage']),
	itemPerPage: state.getIn(['gearSpecListReducer', 'itemPerPage'])
})

const mapDispatchToProps = (dispatch) => ({
	editItem: (gearSpec, pagingData, forInsert) => {
		if (forInsert) {
			dispatch(addGearSpec(gearSpec, pagingData));
		} else {
			dispatch(editGearSpec(gearSpec, pagingData));
		}
	},
	setValue: (id, value) => {
		dispatch(changeGearSpecValue({
			id: id,
			value: value
		}))
	},
	findAllGears: () => {
		dispatch(findAllGears());
	},
	findAllModelNos: () => {
		dispatch(findAllModelNos());
	}
})

const GearSpecEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(GearSpecEditComponent)

export default GearSpecEditContainer;


// WEBPACK FOOTER //
// ./src/containers/GearSpecEditContainer.jsx